export {default as AverageCard} from './chart_Difficulty/Card'